// import { useMediator } from './useMediator';

export const history = () => {
  let __history_steps = [];
  let __history_current_step = 0;
  let _save_step_before_prev = false;

  // const [ getMediator, setMediator, destroyMediator ] = useMediator();

  const __getTourDataByStep = (step) => {
    if (step < 0 || step > __history_steps.length - 1) return [];

    const tourData = __history_steps[step];

    if (!tourData) {
      console.error('tourData is empty', step, __history_steps);
    }

    return tourData;
  };

  const historySave = (tourData) => {
    __history_steps[__history_current_step++] = tourData;
    if (__history_steps.length > __history_current_step)
      __history_steps = __history_steps.slice(0, __history_current_step);

    _save_step_before_prev = true;

    if (__history_steps.length >= 10) {
      __history_steps.shift();
      __history_current_step--;
    }
  };

  const getHistoryPrev = (tourData) => {
    if (_save_step_before_prev) {
      historySave(tourData);
      _save_step_before_prev = false;
      __history_current_step--;
    }
    if (__history_current_step === 0) return null;

    return __getTourDataByStep(--__history_current_step);
  };

  const getHistoryNext = () => {
    if (
      __history_current_step === __history_steps.length ||
      __history_current_step === __history_steps.length - 1
    )
      return [];

    return __getTourDataByStep(++__history_current_step);
  };

  const crearTourHistory = () => {
    __history_steps = [];
    __history_current_step = 0;
    _save_step_before_prev = false;
  };

  const getHistoryInfo = () => ({
    __history_steps,
    __history_current_step,
    _save_step_before_prev,
  });

  return Object.freeze({
    save: historySave,
    goPrev: getHistoryPrev,
    goNext: getHistoryNext,
    clear: crearTourHistory,
    getInfo: getHistoryInfo,
  });
};
